// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__qHkiP","row":"styles_row__UKwWZ"};